// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2 {
   position: relative;
}
h2.sell {
   color: #ffa726;
}
h2.buy {
   color: #2ab4c0;
}
.mat-select {
   margin-left: 4px;
   width: 70px;
}
.close {
   color: #555;
   cursor: pointer;
   position: absolute;
   top: -16px;
   right: -16px;
}
.close:hover {
   color: #f44336;
}

.mat-dialog-content {
   position: relative;
}
.main {
   border-right: 1px solid #dcdcdc;
   border-bottom: 1px solid #dcdcdc;
   width: 401px;
   height: 301px;
   text-align: center;
}
.invisible {
   visibility: hidden;
}
.main>div {
   border-left: 1px solid #dcdcdc;
   border-top: 1px solid #dcdcdc;
   float: left;
   width: 100px;
   height: 100px;
}
.value {
   font-size: 24px;
   margin-top: 4px;
   text-overflow: ellipsis;
   overflow: hidden;
   width: 100%;
}
.sell .ex1 .value {
   color: #ffa726;
}
.buy .ex1 .value {
   color: #2ab4c0;
}
.ex1:hover {
   background-color: #f4f5f7;
   cursor: pointer;
}
.no-value, .desc {
   color: #aaa;
}
.no-value .value {
   font-weight: 300;
}
.desc {
   font-size: 11px;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/report-monthly/monthly.component.css"],"names":[],"mappings":"AAAA;GACG,kBAAkB;AACrB;AACA;GACG,cAAc;AACjB;AACA;GACG,cAAc;AACjB;AACA;GACG,gBAAgB;GAChB,WAAW;AACd;AACA;GACG,WAAW;GACX,eAAe;GACf,kBAAkB;GAClB,UAAU;GACV,YAAY;AACf;AACA;GACG,cAAc;AACjB;;AAEA;GACG,kBAAkB;AACrB;AACA;GACG,+BAA+B;GAC/B,gCAAgC;GAChC,YAAY;GACZ,aAAa;GACb,kBAAkB;AACrB;AACA;GACG,kBAAkB;AACrB;AACA;GACG,8BAA8B;GAC9B,6BAA6B;GAC7B,WAAW;GACX,YAAY;GACZ,aAAa;AAChB;AACA;GACG,eAAe;GACf,eAAe;GACf,uBAAuB;GACvB,gBAAgB;GAChB,WAAW;AACd;AACA;GACG,cAAc;AACjB;AACA;GACG,cAAc;AACjB;AACA;GACG,yBAAyB;GACzB,eAAe;AAClB;AACA;GACG,WAAW;AACd;AACA;GACG,gBAAgB;AACnB;AACA;GACG,eAAe;AAClB","sourcesContent":["h2 {\n   position: relative;\n}\nh2.sell {\n   color: #ffa726;\n}\nh2.buy {\n   color: #2ab4c0;\n}\n.mat-select {\n   margin-left: 4px;\n   width: 70px;\n}\n.close {\n   color: #555;\n   cursor: pointer;\n   position: absolute;\n   top: -16px;\n   right: -16px;\n}\n.close:hover {\n   color: #f44336;\n}\n\n.mat-dialog-content {\n   position: relative;\n}\n.main {\n   border-right: 1px solid #dcdcdc;\n   border-bottom: 1px solid #dcdcdc;\n   width: 401px;\n   height: 301px;\n   text-align: center;\n}\n.invisible {\n   visibility: hidden;\n}\n.main>div {\n   border-left: 1px solid #dcdcdc;\n   border-top: 1px solid #dcdcdc;\n   float: left;\n   width: 100px;\n   height: 100px;\n}\n.value {\n   font-size: 24px;\n   margin-top: 4px;\n   text-overflow: ellipsis;\n   overflow: hidden;\n   width: 100%;\n}\n.sell .ex1 .value {\n   color: #ffa726;\n}\n.buy .ex1 .value {\n   color: #2ab4c0;\n}\n.ex1:hover {\n   background-color: #f4f5f7;\n   cursor: pointer;\n}\n.no-value, .desc {\n   color: #aaa;\n}\n.no-value .value {\n   font-weight: 300;\n}\n.desc {\n   font-size: 11px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
